import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ApiService } from 'src/app/services/api/api.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MaskPipe } from 'ngx-mask';
import { CompanyApiUtils } from 'src/app/helpers/utils';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';

type ProfileProps = {
  label: string;
  value: number;
};

@Component({
  selector: 'app-dashboard-companies-register-bond',
  templateUrl: './dashboard-companies-register-bond.component.html',
  styleUrls: ['./dashboard-companies-register-bond.component.scss'],
})
export class DashboardCompaniesRegisterBondComponent implements OnInit {
  loading: boolean = true;
  loadingProfiles: boolean = false;

  searchForm = this.formBuilder.group({
    avaliableProfiles: [null],
    selectedProfiles: [null],
  });

  data: CompanyBondValues = null;

  avaliableOrderAsc = true;
  selectedOrderAsc = true;
  createdBy: string = '';
  profiles: SelectItem[] = [];

  totalAvaliableOptions = 0;
  avaliableCheckedNumber = 0;
  totalSelectedOptions = 0;
  selectedCheckedNumber = 0;

  profilesSelectedPicked: ProfileProps[] = [];
  profilesAvaliablePicked: ProfileProps[] = [];

  profilesAvaliable: ProfileProps[] = [];
  profilesSelected: ProfileProps[] = [];
  visibleProfilesSelected: ProfileProps[] = [];

  sendingRequest: boolean = false;

  id;

  user: NewLoginResponse | undefined;

  constructor(
    public route: Router,
    public router: ActivatedRoute,
    public formBuilder: FormBuilder,
    private storage: StorageService,
    private authService: AuthService,
    private toast: ToastService,
    private api: ApiService,
    private maskPipe: MaskPipe,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    // if (
    //   !this.authService.verifyPermission(['de_can_add_group_permission']) &&
    //   !this.authService.verifyPermission(['de_can_change_group_permission'])
    // ) {
    //   this.toast.show(
    //     'error',
    //     'Aviso',
    //     'Você não tem permissão para acessar essa página.'
    //   );
    //   this.route.navigateByUrl('/app/dashboard');
    // }

    this.storage.remove('bond');

    this.id = this.router.snapshot.paramMap.get('id');

    this.getData();
    this.setBreadcrumb();

    this.user = this.authService.getUser();

    this.searchForm.controls.avaliableProfiles.valueChanges.subscribe(
      async (value) => {
        this.profilesAvaliablePicked = [];
        await this.getProfilesOptions(value);

        this.filterProfiles();
        this.handleSetNumbers(true);
      }
    );

    this.searchForm.controls.selectedProfiles.valueChanges.subscribe(
      (value) => {
        this.profilesSelectedPicked = [];

        this.visibleProfilesSelected = this.profilesSelected.filter((item) =>
          item.label.toLowerCase().includes(value.toLowerCase())
        );
        this.handleSetNumbers();
      }
    );
  }

  handleCheckAll(isAvaliable: boolean = false) {
    if (isAvaliable) {
      const valuesMissingInPicked = this.profilesAvaliable.filter(
        (item) =>
          !this.profilesAvaliablePicked.some(
            (picked) => picked.value === item.value
          )
      );

      if (valuesMissingInPicked.length === 0) {
        this.profilesAvaliablePicked = [];
        this.handleSetNumbers();
        return;
      }

      valuesMissingInPicked.forEach((item) => {
        this.profilesAvaliablePicked.push(item);
      });
      this.handleSetNumbers();
    } else {
      const valuesMissingInPicked = this.visibleProfilesSelected.filter(
        (item) =>
          !this.profilesSelectedPicked.some(
            (picked) => picked.value === item.value
          )
      );

      if (valuesMissingInPicked.length === 0) {
        this.profilesSelectedPicked = [];
        this.handleSetNumbers();
        return;
      }

      valuesMissingInPicked.forEach((item) => {
        this.profilesSelectedPicked.push(item);
      });
      this.handleSetNumbers();
    }
  }

  verifyCheckAll(isAvaliable: boolean = false) {
    if (isAvaliable) {
      return (
        this.profilesAvaliablePicked.length === this.profilesAvaliable.length
      );
    }
    return (
      this.profilesSelectedPicked.length === this.visibleProfilesSelected.length
    );
  }

  filterProfiles() {
    this.profilesAvaliable = this.profilesAvaliable.filter((item) => {
      return !this.profilesSelected.some(
        (selected) => selected.value === item.value
      );
    });
  }

  async getData() {
    await this.companyData();
    await this.getProfilesOptions();

    this.handleSetNumbers(true);
    this.handleSetNumbers();

    this.loading = false;
  }

  async companyData() {
    try {
      const id = this.router.snapshot.paramMap.get('id');

      const res = await this.api.get({
        route: `api/v3/companies/${id}/`,
        token: true,
        params: {
          tab: 'company_data',
        },
      });

      this.data = res;
      // Converter status para exibição se necessário
      if (res.status) {
        (this.data as any).statusDisplay = CompanyApiUtils.getStatusDisplay(
          res.status,
          'company'
        );
      }
      this.setBreadcrumb(); // Atualizar breadcrumb após carregar os dados
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
    this.loading = false;
  }

  //   async getProfiles() {
  //     try {
  //       const groupId = this.router.snapshot.params.groupId;
  //       const params = {
  //         status: 'Ativo',
  //       };

  //       if (groupId) {
  //         params['company'] = this.data.company_id;
  //       }

  //       const res = await this.api.get({
  //         route: `api/v2/user-profile`,
  //         token: true,
  //         params,
  //       });

  //       this.createdBy = res.created_by === '' ? 'Sistema' : res.created_by;

  //       this.profilesSelected = res.results
  //         .filter((i) => i.status === 'Ativo')
  //         .map((item) => ({
  //           label: item.name,
  //           value: item.id,
  //         }));

  //       this.profilesSelected.forEach((profile) => {
  //         this.profilesAvaliable = this.profilesAvaliable.filter(
  //           (item) => item.value !== profile.value
  //         );
  //       });

  //       //   this.visibleProfilesSelected = this.profilesSelected;
  //     } catch (error) {
  //       this.toast.show('error', 'Erro', 'Erro ao carregar os dados');
  //     }
  //   }

  async getProfilesOptions(param?: string) {
    this.loadingProfiles = true;
    try {
      const groupId = this.router.snapshot.params.groupId;
      const params: any = {};

      if (param) {
        params.search = param;
      }

      params.status = 'Ativo';

      if (groupId !== undefined) {
        params.company = this.data.company_id;
      }

      const res = await this.api.get({
        route: `api/v2/user-profile/`,
        token: true,
        params,
      });

      this.profiles = res.results
        .filter((i) => i.status === 'Ativo')
        .map((item) => ({
          label: item.name,
          value: item.id,
        }));

      this.profilesAvaliable = this.profiles;
    } catch (error) {
      console.error('Erro ao buscar perfis:', error);
      this.toast.show('error', 'Erro', 'Erro ao buscar perfis');
    } finally {
      this.loadingProfiles = false;
    }
  }

  toggleValue(item: ProfileProps, isAvaliable: boolean = false) {
    if (isAvaliable) {
      if (this.isOptionsChecked(item, true)) {
        this.profilesAvaliablePicked = this.profilesAvaliablePicked.filter(
          (profile) => profile.value !== item.value
        );
      } else {
        this.profilesAvaliablePicked.push(item);
      }

      this.handleSetNumbers(true);
    } else {
      if (this.isOptionsChecked(item, false)) {
        this.profilesSelectedPicked = this.profilesSelectedPicked.filter(
          (profile) => profile.value !== item.value
        );
      } else {
        this.profilesSelectedPicked.push(item);
      }

      this.handleSetNumbers();
    }
  }

  isOptionsChecked(item: ProfileProps, isAvaliable: boolean = false) {
    if (isAvaliable) {
      return this.profilesAvaliablePicked.some(
        (profile) => profile.value === item.value
      );
    }
    return this.profilesSelectedPicked.some(
      (profile) => profile.value === item.value
    );
  }

  getDisabled(isAvaliable: boolean = false) {
    return isAvaliable
      ? this.profilesAvaliablePicked.length === 0
      : this.profilesSelectedPicked.length === 0;
  }

  changeSide(isAvaliable: boolean = false) {
    if (isAvaliable) {
      this.profilesAvaliablePicked.forEach((profile) => {
        this.profilesSelected.push(profile);
        this.visibleProfilesSelected.push(profile);

        this.profilesAvaliable = this.profilesAvaliable.filter(
          (item) => item.value !== profile.value
        );
      });

      //   remove repeated values from profilesSelected

      this.profilesSelected = this.profilesSelected.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );

      this.visibleProfilesSelected = this.visibleProfilesSelected.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );

      // -----

      const searchFormValue = this.searchForm.controls.selectedProfiles.value;

      if (searchFormValue)
        this.searchForm.controls.selectedProfiles.setValue(searchFormValue);

      this.profilesAvaliablePicked = [];
    } else {
      this.profilesSelectedPicked.forEach((profile) => {
        // this.profilesAvaliable.push(profile);

        this.profilesSelected = this.profilesSelected.filter(
          (item) => item.value !== profile.value
        );

        this.visibleProfilesSelected = this.visibleProfilesSelected.filter(
          (item) => item.value !== profile.value
        );
      });

      this.profilesSelectedPicked = [];
      const searchFormValue = this.searchForm.controls.avaliableProfiles.value;
      this.searchForm.controls.avaliableProfiles.setValue(searchFormValue);
    }

    this.handleSetNumbers(true);
    this.handleSetNumbers();
  }

  getSubmitDisabled() {
    return this.sendingRequest || this.profilesSelected.length === 0;
  }

  handleSetNumbers(isAvaliable: boolean = false) {
    if (isAvaliable) {
      this.totalAvaliableOptions = this.profilesAvaliable.length;
      this.avaliableCheckedNumber = this.profilesAvaliablePicked.length;
    } else {
      this.totalSelectedOptions = this.visibleProfilesSelected.length;
      this.selectedCheckedNumber = this.profilesAvaliablePicked.length;
    }
  }

  async handleAddBond() {
    this.sendingRequest = true;
    try {
      const payload = {
        user_profile: this.profilesSelected.map((item) => item.value),
        company_document: this.data.document_number,
        company_name: this.data.corporate_name,
        company: this.data.company_id,
        owner: this.data.owner,
      };

      const groupId = this.router.snapshot.params.groupId;

      if (groupId) {
        payload['group'] = Number(groupId);
      }

      await this.api.post({
        route: 'api/v2/user-profile-permission/',
        body: payload,
        token: true,
      });

      if (groupId !== undefined) {
        this.route.navigateByUrl(
          `app/permissions/companies/${this.id}/group/details/${groupId}`
        );
      } else {
        this.route.navigateByUrl(
          `app/permissions/companies/details/${this.id}`
        );
      }

      this.toast.show('info', 'Sucesso', 'Vínculo adicionado com sucesso.');
    } catch (error) {
      console.error('Erro ao adicionar vínculo:', error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao adicionar o vínculo.'
      );
    } finally {
      this.sendingRequest = false;
    }
  }

  handleCancel() {
    this.storage.remove('bond');

    const groupId = this.router.snapshot.params.groupId;

    this.route.navigateByUrl(
      !groupId
        ? `app/permissions/companies/details/${this.id}`
        : `app/permissions/companies/${this.id}/group/details/${groupId}`
    );
  }

  formatDocument(document: string) {
    const newValue = this.maskPipe.transform(document, '00.000.000/0000-00');

    return newValue;
  }

  setBreadcrumb(): void {
    const canViewCompanies = this.authService.verifyPermission(
      'de_can_view_companies'
    );
    const companyId = this.router.snapshot.paramMap.get('id');
    const groupId = this.router.snapshot.paramMap.get('groupId');
    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: 'Empresas',
        url: '/app/permissions/companies',
        clickable: canViewCompanies,
      },
      {
        label: this.data?.corporate_name || 'Detalhes da empresa',
        url: `/app/permissions/companies/details/${companyId}`,
        clickable: canViewCompanies,
      },
    ];

    if (groupId) {
      breadcrumbs.push({
        label: 'Detalhes do grupo',
        url: `/app/permissions/companies/${companyId}/group/details/${groupId}`,
        clickable: canViewCompanies,
      });
    }

    breadcrumbs.push({
      label: 'Vincular perfis de usuário',
      url: this.route.url,
      clickable: false, // Página atual, não precisa ser clicável
    });

    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }
}
